<template>
  <!-- 解决方案-主页面 -->
  <div class="solution-container">
    <h1 class="page-title">解决方案</h1>
    <div class="solution-list">
      <div
        v-for="(item, index) in currentPageData.solutions"
        :key="item.id"
        class="solution-item"
        :class="{ 'reverse': index % 2 !== 0 }"
        @mouseenter="handleMouseEnter(item.id)"
        @mouseleave="handleMouseLeave(item.id)">
        <div class="image-wrapper">
          <img :src="item.image" :alt="item.title">
        </div>
        <div class="content-wrapper">
          <h3 class="title">{{ item.title }}</h3>
          <p class="description">{{ item.description }}</p>
          <el-button class="detail-btn" @click="goToDetail(item)">查看更多</el-button>
          <div class="progress-line" :class="{ 'active': activeItem === item.id }"></div>
        </div>
      </div>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalPages * 10"
        :current-page.sync="currentPage"
        @current-change="handlePageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import solutionListData from '@/data/solutionListData'

export default {
  name: 'SolutionMain',
  data() {
    return {
      currentPage: 1,
      activeItem: null,
      solutionData: solutionListData
    }
  },
  computed: {
    totalPages() {
      return this.solutionData.length
    },
    currentPageData() {
      return this.solutionData.find(page => page.pageIndex === this.currentPage) || { solutions: [] }
    }
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page
    },
    handleMouseEnter(id) {
      this.activeItem = id
    },
    handleMouseLeave() {
      this.activeItem = null
    },
    goToDetail(item) {
      if (!item) return
      const targetPath = item.detailPath || item.link || `/solution/${item.id}`
      if (targetPath) {
        this.$router.push(targetPath)
      } else {
        this.$message?.warning('暂未配置详情页面')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.solution-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  .page-title {
    text-align: center;
    font-size: 32px;
    color: rgba(5, 85, 182, 1);
    margin-bottom: 40px;
  }

  .solution-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 40px;
  }

  .solution-item {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &.reverse {
      flex-direction: row-reverse;

      .content-wrapper {
        padding-left: 60px;
        padding-right: 40px;
      }
    }

    &:hover {
      transform: translateY(-5px);

      .image-wrapper img {
        transform: scale(1.1);
      }
    }
  }

  .image-wrapper {
    flex: 0 0 50%;
    height: 360px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s ease;
    }
  }

  .content-wrapper {
    flex: 1;
    padding: 40px 60px 40px 40px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      font-size: 28px;
      color: rgba(5,85,182,1);
      margin-bottom: 20px;
    }

    .description {
      font-size: 14px;
      color: rgba(102,102,102,1);
      line-height: 1.8;
      margin-bottom: 30px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .detail-btn {
      align-self: flex-start;
      padding: 12px 24px;
      font-size: 16px;
      margin-bottom: 20px;
    }

    .progress-line {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: #409EFF;
      transition: width 0.6s ease;

      &.active {
        width: 100%;
      }
    }
  }

  .pagination-wrapper {
    text-align: center;
    margin-top: 60px;
  }
}

@media screen and (max-width: 992px) {
  .solution-container {
    .solution-item {
      flex-direction: column !important;
      gap: 0;

      .image-wrapper {
        flex: none;
        height: 240px;
        width: 100%;
      }

      .content-wrapper {
        padding: 30px !important;

        .title {
          font-size: 24px;
          margin-bottom: 15px;
        }

        .description {
          font-size: 14px;
          margin-bottom: 20px;
        }

        .detail-btn {
          padding: 10px 20px;
          font-size: 14px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .solution-container {
    padding: 20px;

    .page-title {
      font-size: 24px;
      margin-bottom: 30px;
    }

    .solution-list {
      gap: 30px;
    }

    .solution-item {
      .image-wrapper {
        height: 200px;
      }

      .content-wrapper {
        padding: 20px !important;

        .title {
          font-size: 20px;
        }

        .description {
          font-size: 13px;
          -webkit-line-clamp: 3;
        }
      }
    }
  }
}
</style>
